import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import find from 'lodash/find'
import cloneDeep from 'lodash/cloneDeep'
import { Button } from 'reactstrap'
import SearchIcon from "../../../../static/images/search_icon.svg"
import metrolendarHelper from '../../../timesheet/helpers/date'
import "../../../../static/css/index.css"
import { ApproveTimesheetForm } from '../../form/approve-timesheet'
import { FONTS } from '../../../../constants'
import moment from '../../../../lib/moment.js'

const ButtonDetail = (props) => {
  const can_approve = get(props, 'can_approve')
  const {
    isClickApproveOrReject,
    clickApproveOrReject,
    handleRemark,
    handleClickButton,
  } = props
  const month = get(props, 'month')
  const approveDate = get(props, 'approveDate')
  const weekdates = get(props, 'weekdates')
  const handleDate = get(props, 'handleDate')
  const startWeek = get(weekdates, '0') ? `${get(weekdates, '0').format('DD')} ${get(weekdates, '0').format('MMM')}` : ''
  const endWeek = get(weekdates, `${weekdates.length - 1}`) ? `${get(weekdates, `${weekdates.length - 1}`).format('DD')} ${get(weekdates, `${weekdates.length - 1}`).format('MMM')}` : ''
  return (
    <Wrapper>
      <Buttons>
        <ApproveTimesheetForm
          { ...props }
          open={ isClickApproveOrReject }
          handleRemark={ handleRemark }
          handleClickButton={ (isApprove) => handleClickButton(isApprove) }
          clickApproveOrReject={ (type) => clickApproveOrReject(type) }
        />
        { can_approve &&
        <CustomButton
          color='success'
          onClick={ () => clickApproveOrReject('approve') }
        >
          Approve
        </CustomButton>
        }
        { can_approve &&
        <CustomButton
          color='danger'
          onClick={ () => clickApproveOrReject('reject') }
        >
          Reject
        </CustomButton>
        }
      </Buttons>
      {/* timesheet mobile */}
      <DateGroupMobile>
        <ArrowButton
          background='white'
          style={ {
            visibility: moment(moment(approveDate).clone().add(-1, 'week').day(6)).format('MM') === month ? 'visible' : 'hidden',
          } }
          onClick={ () => {
            handleDate(moment(approveDate.add(-1, 'week')).day(6))
          } }
        >&#65308;</ArrowButton>
        <LabelMonth>
          { startWeek }  - { endWeek }
        </LabelMonth>
        <ArrowButton
          background='white'
          style={ {
            visibility: moment(moment(approveDate).clone().add(1, 'week').day(1)).format('MM') === month ? 'visible' : 'hidden',
          } }
          onClick={ () => {
            handleDate(moment(approveDate.add(1, 'week')).day(6))
          } }
        >&#65310;</ArrowButton>
        {/* <CustomDatePicker
          customInput={ <CustomButtonDate /> }
          onChange={ handleDate }
          placeholderText='DD/MM/YYYY'
          selected={ get(props, 'selectedDate') }
          dateFormat="DD/MM/YYYY"
          popperPlacement="bottom-end"
          showYearDropdown
          showMonthDropdown
          dropdownMode="select"
        /> */}
      </DateGroupMobile>
      {/* timesheet mobile */}
    </Wrapper>
  )
}

const ButtonList = (props) => {
  const {
    handleInputTimesheetApproval,
    handleSearch,
    tempSearch,
  } = props

  return (
    <Buttons>
      <SearchField
        placeholder='Search by employee'
        value={ tempSearch }
        onChange={ (e) => {
          if (e.target.value === '') handleInputTimesheetApproval('searchApproval', e.target.value)
          handleSearch(e.target.value)
        } }
        onKeyDown={ (e) => {
          if (e.keyCode === 13) handleInputTimesheetApproval('searchApproval', tempSearch)
        } }
      />
    </Buttons>
  )
}


export const TimesheetApprovalButton = class extends React.Component {
  state={
    isClickApproveOrReject: false,
    tempSearch: this.props.searchApproval,
  }

  handleApproveDate = (date) => {
    this.setState({
      weekdates: metrolendarHelper.getTableWeekDates(date),
      selectedDate: date,
    })
  }

  clickApproveOrReject = (isApprove) => {
    this.setState({
      isApprove,
      isClickApproveOrReject: !this.state.isClickApproveOrReject,
      remark: '',
    })
  }

  handleRemark = (e) => {
    this.setState({ remark: e.target.value })
  }

  handleClickButton = (isApprove) => {
    const approveTimesheet = get(this.props, 'approveTimesheet')
    const requestID = get(this.props, 'timesheetRequest.timesheetRequest._id')
    const payload = { remark: this.state.remark }
    if (isApprove === 'approve') {
      payload.is_approve = true
      approveTimesheet(requestID, payload)
    } else if (isApprove === 'reject') {
      payload.is_approve = false
      approveTimesheet(requestID, payload)
    }
    this.setState({
      isClickApproveOrReject: !this.state.isClickApproveOrReject,
      remark: '',
    })
  }

  render() {
    const {
      timesheetRequest,
      handleInputTimesheetApproval,
    } = this.props
    const weekdates = get(this.props, 'weekdates')
    const handleDate = get(this.props, 'handleDate')
    const can_approve = get(timesheetRequest, 'timesheetRequest.can_approve')
    const month = moment(get(this.props.timesheetRequest, 'timesheetRequest.timesheet_snapshot.month')).format('MM')
    const setDate = moment(get(this.props.timesheetRequest, 'timesheetRequest.timesheet_snapshot.month'))
    const selectedDate = cloneDeep(get(this.props, 'selectedDate'))
    const week = metrolendarHelper.getTableWeekDates(moment(setDate), 'month')
    const date = find(weekdates, (time) => {
      const d1 = moment(selectedDate).format('YYYY-MM-DD')
      const d2 = moment(time).format('YYYY-MM-DD')
      if (d1 === d2) return moment(date).format('YYYY-MM-DD')
      return null
    })

    if (get(this.props, 'location') === `/time_sheet/approval/${get(this.props, 'path')}`) {
      return (
        <ButtonDetail
          { ...this.state }
          can_approve={ can_approve }
          month={ month }
          clickApproveOrReject={ this.clickApproveOrReject }
          handleRemark={ this.handleRemark }
          handleClickButton={ this.handleClickButton }
          weekdates={ (selectedDate.isSame(moment(), 'day') && selectedDate.isSame(moment(), 'month')) ? week : weekdates }
          handleDate={ handleDate }
          approveDate={ selectedDate.isSame(moment(), 'day') && selectedDate.isSame(moment(), 'month') ? setDate : selectedDate }
          handleApproveDate={ this.handleApproveDate }
          timesheetRequest={ timesheetRequest }
        />
      )
    } return (
      <ButtonList
        { ...this.state }
        handleInputTimesheetApproval={ handleInputTimesheetApproval }
        handleSearch={ (e) => this.setState({ tempSearch: e }) }
      />
    )
  }
}

TimesheetApprovalButton.propTypes = {
  timesheetRequest: PropTypes.object,
  handleInputTimesheetApproval: PropTypes.func.isRequired,
  searchApproval: PropTypes.string,
  handleDate: PropTypes.func.isRequired,
}
TimesheetApprovalButton.defaultProps = {
  timesheetRequest: {},
  searchApproval: '',
}
ButtonDetail.propTypes = {
  isClickApproveOrReject: PropTypes.bool.isRequired,
  clickApproveOrReject: PropTypes.func.isRequired,
  handleRemark: PropTypes.func.isRequired,
  handleClickButton: PropTypes.func.isRequired,
}
ButtonList.propTypes = {
  handleInputTimesheetApproval: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  tempSearch: PropTypes.string,
}
ButtonList.defaultProps = {
  tempSearch: '',
}

const Buttons = styled.div`
  position: absolute;
  display: flex;
  right: 10px;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  @media (max-width: 767.98px) {
    display: none;
  }
`
const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`
const CustomButton = styled(Button)`
  margin-right: 10px ;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const SearchField = styled.input`
  width: 100%;
  height: 30px;
  padding-left: 30px;
  background : url(${SearchIcon}) no-repeat scroll 5%;
  background-size : 15px 15px;
  font-family : ${FONTS.GOTHAM} !important;
  font-size : ${FONTS.SMALL_SIZE};
  border : 1px solid #ccc;
  border-radius: 4px;
  margin-left: 2% !important;
  margin-right: 10px;
  margin-top:auto;
  margin-bottom:auto;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
`
const DateGroupMobile = styled.div`
  .react-datepicker-popper {
      z-index: 3;
  }
  @media (max-width: 1199.98px) {
    display: none;
  }
  @media (max-width: 991.98px) {
    display: none;
  }
  @media (max-width: 575.98px) {
    height: 50%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
  @media (max-width: 767.98px) {
    height: 50%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const ArrowButton = styled(Button)`
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  background: ${(props) => { return props.background }} ;
  width: 15%;
  color: black;
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #E6E6E6;
  @media (max-width: 575.98px) {
    border: none;
    font-size: 12px;
    color: white;
    background: #D44B49;
    margin-left: 0px;
    padding: 0px !important;
  }
  @media (max-width: 767.98px) {
    border: none;
    font-size: 12px;
    color: white;
    background: #D44B49;
    margin-left: 0px;
    padding: 0px !important;
  }
`
const LabelMonth = styled.label`
  width: 70px;
  font-size: ${FONTS.SMALL_SIZE};
  margin-top: 2%;
  text-align: center;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  @media (max-width: 575.98px) {
    width: 120px;
    margin-bottom: 0px !important;
    font-size: 12px !important;
    color: white;
    margin-left: 0px!important;
  }
  @media (max-width: 767.98px) {
    width: 120px;
    margin-bottom: 0px !important;
    font-size: 12px !important;
    color: white;
    margin-left: 0px!important;
  }
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab/button-group/timesheet-approval-button.js